<template>
  <div>
    <el-input placeholder="" readonly :value="displayValue" :clearable="true" @change="handleChange">
      <template slot="append"><el-button type="primary" @click="open">选择</el-button></template>
    </el-input>

      <mw-dialog title="选择部门机构" size="small_large" :footerButton="btns" ref="zgDeptDialog" :close-on-click-modal="false">
        <mw-tree
          :url="deptTreeUrl"
          :multipleLeaf="true"
          :selectFirst="true"
          :async="true"
          :expandedFirst="true"
          ref="deptTree"
          :multiple="false"
          @changed="handleSelect"
          class="mw-dialog-body" />
      </mw-dialog>

  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: {}
    }
  },

  data() {
    return {
      // deptTreeUrl: this.mwUrl("/api/org/listDepartment"),
      checkNodes: [],
      btns: [
        {
          label: "确定",
          func: this.close
        }
      ]
    };
  },
  computed: {
    deptTreeUrl() {
      // 不是开发账号过滤不显示的部门
      if (!this.userInfo || !this.userInfo.developer) return this.mwUrl("/api/org/listDepartmentListAble");
      return this.mwUrl("/api/org/listDepartment")
    },
    displayValue() {
      if (this.value) {
        if (this.value.name !== undefined) {
          return this.value.name;
        }
      }
      return "";
    }
  },
  methods: {
    close() {
      this.mwRef("zgDeptDialog").hide();
    },

    open() {
      this.mwRef("zgDeptDialog").show();
      // PF.show(
      //   "tree",
      //   {
      //     url: this.mwUrl("/api/org/listDepartment"),
      //     checkNodes: [],
      //     multiple: false,
      //     // singleLeaf: true,
      //     // multipleLeaf: true,
      //     clearBtn: false,
      //     search: true
      //   },
      //   res => {
      //     if (res) {
      //       this.$emit('input', res)
      //     }
      //   }
      // );
    },

    handleSelect(data) {
      this.$emit("input", data);
    },
    handleChange(val) {
      if (!val) {
        this.$emit('input', {});
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/flowInterfering/common/unitSelect.vue